import { Link } from "react-router-dom";

export function AllianceNavLinks({ t, checkIfActive, navbarTextColor }) {
  return (
    <>
      <Link
        to={"/datasets"}
        className={`grid grid-cols-[max-content_max-content] gap-0.5 items-center border-none bg-none cursor-pointer font-medium transition-all duration-200 ease-in-out hover:scale-110 hover:text-[#f2987a] focus:text-[#f2987a] focus:outline-none ${
          checkIfActive("/products") ? "text-amber-500" : ""
        }`}
        style={
          !checkIfActive("/products") ? { color: navbarTextColor } : undefined
        }
        data-testid="allProductsNav"
      >
        {t("allDatasets")}
      </Link>
      <Link
        to={"/systemic-innovations"}
        className={`grid grid-cols-[max-content_max-content] gap-0.5 items-center border-none bg-none cursor-pointer font-medium transition-all duration-200 ease-in-out hover:scale-110 hover:text-[#f2987a] focus:text-[#f2987a] focus:outline-none ${
          checkIfActive("/products") ? "text-amber-500" : ""
        }`}
        style={
          !checkIfActive("/products") ? { color: navbarTextColor } : undefined
        }
        data-testid="allProductsNav"
      >
        {t("allSystemicInnovations")}
      </Link>
      <div />

      <Link
        to={"/my-datasets"}
        className={`grid grid-cols-[max-content_max-content] gap-0.5 items-center border-none bg-none cursor-pointer font-medium transition-all duration-200 ease-in-out hover:scale-110 hover:text-[#f2987a] focus:text-[#f2987a] focus:outline-none ${
          checkIfActive("/asset-management") ? "text-amber-500" : ""
        }`}
        style={
          !checkIfActive("/asset-management")
            ? { color: navbarTextColor }
            : undefined
        }
        data-testid="myProductsNav"
      >
        {t("myDatasets")}
      </Link>
      <Link
        to={"/my-systemic-innovations"}
        className={`grid grid-cols-[max-content_max-content] gap-0.5 items-center border-none bg-none cursor-pointer font-medium transition-all duration-200 ease-in-out hover:scale-110 hover:text-[#f2987a] focus:text-[#f2987a] focus:outline-none ${
          checkIfActive("/asset-management") ? "text-amber-500" : ""
        }`}
        style={
          !checkIfActive("/asset-management")
            ? { color: navbarTextColor }
            : undefined
        }
      >
        {t("mySystemicInnovations")}
      </Link>
    </>
  );
}
